import describeShowWhen from '../../helpers/questionnaire/describeShowWhen'

// De chip achter een conditionele vraag in de vragenlijstbouwer.
//
// Zonder dit label is de lijst niet meer te lezen: een bouwer ziet anders een
// vraag staan die respondenten misschien nooit krijgen. Bij een verwijderde
// triggervraag wordt de chip een waarschuwing — de vraag wordt dan altijd
// getoond (fail-open), en dat moet zichtbaar zijn.
// AI-CONTEXT: See docs/features/conditional-questions.md

/**
 * @param {object} props
 * @param {object} props.field - Het QuestionnaireFields-doc met (mogelijk) een ShowWhen
 * @param {Array<object>} props.allFields - Alle velden van de vragenlijst
 * @param {Object<string, string>} [props.valueLabels] - Optie-/kolom-/rij-ID's
 *   naar hun tekst; zonder labels noemt de chip alleen de triggervraag
 */
const ShowWhenChip = ({ field, allFields, valueLabels }) => {
    const { state, text } = describeShowWhen(field, allFields, valueLabels)
    if (state === 'none') return null

    return (
        <span
            className={`qb-showwhen-chip${state === 'missing-trigger' ? ' warn' : ''}`}
            title={text}
        >
            {text}
        </span>
    )
}

export default ShowWhenChip
